<template>
  <section class="hotel-detail">
    <nav-bar :class="{ show: isActive }"></nav-bar>
    <div class="container-detail">
      <div class="links-wrapper">
        <links></links>
      </div>
      <detail-header :hotel="hotel"></detail-header>
      <detail-summary :hotel="hotel"></detail-summary>
      <room-picker :hotel="hotel"></room-picker>
      <location-detail :hotel="hotel"></location-detail>
      <detail-info :hotel="hotel"></detail-info>
      <similar-hotels></similar-hotels>
    </div>
    <contact-footer :showFooter="true"></contact-footer>
    <legal-footer :showFooter="true"></legal-footer>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

// import TitleSetter from '@/components/TitleSetter'
import NavBar from "@/components/Navbar";
import Links from "@/components/Links";
import DetailHeader from "../components/hotel-detail-page/DetailHeader";
import DetailSummary from "../components/hotel-detail-page/DetailSummary";
import RoomPicker from "../components/hotel-detail-page/RoomPicker";
import LocationDetail from "@/components/hotel-detail-page/LocationDetail";
import DetailInfo from "../components/hotel-detail-page/DetailInfo";
import SimilarHotels from "../components/hotel-detail-page/SimilarHotels";
import ContactFooter from "@/components/landing-page/ContactFooter";
import LegalFooter from "@/components/landing-page/LegalFooter";

export default {
  name: "detail",
  components: {
    // TitleSetter,
    NavBar,
    Links,
    DetailHeader,
    DetailSummary,
    RoomPicker,
    LocationDetail,
    DetailInfo,
    SimilarHotels,
    ContactFooter,
    LegalFooter
  },

  data: () => {
    return {
      hotelId: null,
      hotel: null,
      isActive: true
    };
  },
  watch: {
    $route(to, from) {
      this.hotel = this.$store.getters.hotel(to.params.id);
    }
  },
  computed: {
    ...mapGetters(["congressName", "dataIsReady"])
  },
  created() {
    this.hotelId = Number(this.$route.params.id);
    this.$store.watch(({ dataIsReady }, { hotel: getHotelData }) => {
      if (dataIsReady) {
        this.hotel = getHotelData(this.hotelId);
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.hotel-detail {
  height: 100%;
  text-align: left;
  color: $secondary-black;
  margin: 0;

  .links-wrapper {
    padding-top: 60px;
    margin-bottom: 40px;
    overflow: scroll;
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.1);

    .links {
      padding-left: 0;

      a {
        font-weight: bold;
        color: #747272;
        font-size: 14px;
      }
    }
  }
}

@media (min-width: 768px) {
  .hotel-detail {
    padding-top: 140px;
  }
  .container-detail {
    max-width: 1200px;
    margin: 0 auto;

    .links-wrapper {
      display: none;
    }
  }
}
</style>
